// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application';

import CurrencyController from './currency_controller';
application.register('currency', CurrencyController);

import DialogController from './dialog_controller';
application.register('dialog', DialogController);

import MailtoController from './mailto_controller';
application.register('mailto', MailtoController);

import MenuController from './menu_controller';
application.register('menu', MenuController);

import TicketPriceTrendController from './ticket_price_trend_controller';
application.register('ticket-price-trend', TicketPriceTrendController);
